import {Component, Input, OnInit} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import {AlertUserData} from '../../../models/alert-user-data';
import {KeyTextService} from '../../../services/key-text/key-text.service';
import {CommonModule} from "@angular/common";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'colimo-color',
  templateUrl: 'color.component.html',
  styleUrls: ['color.component.scss'],
  imports: [
    CommonModule,
    MatTooltip,
    TranslateModule
  ]
})
export class ColorComponent implements OnInit {
  @Input() public gradient: { type: string; start: string; end: string };
  @Input() public hasWarning: boolean;
  @Input() public size: string;
  @Input() public removeCorner: boolean;
  @Input() public imgJpeg: string;
  @Input() public alerts: AlertUserData[];

  public sanitizer: DomSanitizer;
  public maxAlertLevel: number = 0;
  public alertToolTip: string = '';
  private componentTranslations: string[] = [];

  constructor(sanitizer: DomSanitizer,
              private readonly keyTextService: KeyTextService) {
    this.sanitizer = sanitizer;
  }

  public ngOnInit(): void {
    if (this.alerts && this.alerts.length > 0) {
      this.keyTextService.getComponentTranslationsObservable().subscribe({
        next: (compTranslations: string[]) => {
          this.componentTranslations = compTranslations;
          this.initAlertTooltip();
        }, error: () => {
          //nothing
        }
      });
    }
  }

  private initAlertTooltip(): void {
    this.alertToolTip = '';
    let maxLevel = 0;
    for (let i = 0; i < this.alerts.length; i++) {
      let infoText = this.alerts[i].info;
      if (this.alerts[i].typ === 'WP') {
        // translate component if its worst part alert
        const translatedComponent = this.componentTranslations[this.alerts[i].component] ? this.componentTranslations[this.alerts[i].component] : this.alerts[i].component;
        infoText = this.alerts[i].info.replace('{component}', translatedComponent);
      }
      // #594842 - Shorten color card warning tooltip for alerts that are too long
      if (this.alerts[i].typ === 'SPC') {
        infoText = this.shortenSpcTooltip(infoText);
      }
      if (this.alerts[i].typ === 'NBD') {
        infoText = this.shortenBatchDeviationTooltip(infoText);
      }
      this.alertToolTip += this.getAlertLevelIndicator(this.alerts[i].alertLevel) + ' ' + infoText + ' - ' + this.alerts[i].batchNr + ' - ' + this.alerts[i].productNr + ' - ' + this.alerts[i].line + '\n';
      if (this.alerts[i].alertLevel > maxLevel) {
        maxLevel = this.alerts[i].alertLevel;
      }
    }
    this.maxAlertLevel = maxLevel;
  }

  public shortenSpcTooltip(info: string): string {
    const match = info.match(
      /SPC accumulated (\d+) of (\d+) (.+?) measurements .* in (.+?) components at a (\d+°)/i
    );

    if (!match) {
      return info;
    }

    const [, count, total, db, location, angle] = match;

    return `SPC ${count} of ${total} ${db} ${location} at ${angle}`;
  }

  private shortenBatchDeviationTooltip(info: string): string {
    const match = info.match(
      /New batch deviation (\d+°)\s+prev:(\d+)/i
    );

    if (!match) {
      return info;
    }

    const [, angle, batchNr] = match;

    return `Batch deviation ${angle} prev:${batchNr}`;
  }

  private getAlertLevelIndicator(level: number): string {
    if (level >= 2000) {
      // unicode for red circle
      return '\u{1F7E0}';
    } else {
      // unicode for yellow circle
      return '\u{1F7E1}';
    }
  }

  public trustedStyle(style: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }
}
